import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from '../../i18n';
import { Container, ErrorImage, ErrorTitle, ErrorMessage, ErrorButton, ErrorInnerContainer } from './styles';
var CameraError = function (_a) {
    var cameraNotFound = _a.cameraNotFound, cameraPermission = _a.cameraPermission, retrying = _a.retrying, setRetrying = _a.setRetrying, setCameraPermission = _a.setCameraPermission, message = _a.message, onRetry = _a.onRetry;
    var t = useTranslation().t;
    var renderErrorMessages = function () {
        if (message) {
            return React.createElement(React.Fragment, null,
                React.createElement(ErrorInnerContainer, { role: "alert" },
                    React.createElement(ErrorTitle, null, t('camera.failureTitle')),
                    React.createElement(ErrorMessage, null, message)),
                onRetry && React.createElement(ErrorButton, { onClick: onRetry }, t('common.tryAgain')));
        }
        if (cameraNotFound) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ErrorInnerContainer, null,
                    React.createElement(ErrorImage, { src: "./core-sdk/FaceTec_images/FaceTec_camera.png" }),
                    React.createElement(ErrorTitle, null, t('camera.notFoundTitle')),
                    React.createElement(ErrorMessage, null, t('camera.notFoundMessage')))));
        }
        if (!cameraPermission) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ErrorInnerContainer, null,
                    React.createElement(ErrorImage, { src: "./core-sdk/FaceTec_images/FaceTec_camera.png" }),
                    React.createElement(ErrorTitle, null, t('camera.enableTitle')),
                    React.createElement(ErrorMessage, null, t('camera.enableMessage'))),
                React.createElement(ErrorButton, { onClick: function () {
                        toast.dismiss();
                        setRetrying(true);
                        setCameraPermission(true);
                    } }, "OK")));
        }
    };
    useEffect(function () {
        if (retrying) {
            toast.error(t('camera.permissionDenied'), {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
            });
        }
        ;
    }, []);
    return (React.createElement(Container, null, renderErrorMessages()));
};
export default CameraError;
